<ng-container *ngIf="events">
  <div class="container-header-calendar d-flex justify-content-between align-items-center w-100 bg-brand-99">
    <div class="col-md-4">
      <div class="btn-group">
        <div class="text-brand-40 cursor-pointer" mwlCalendarPreviousView [view]="view" [(viewDate)]="viewDate" role="button" tabindex="0"
          (viewDateChange)="onViewChange(viewDate)">
          <img loading="lazy" src="./assets/images/calendar/arrow_left_calendar.svg" alt="icon_prev | Lumsa" style="width: 16px; height: 28px;">
        </div>
      </div>
    </div>
    <div class="col-md-4 text-center">
      <p class="m-0 ls-label-medium-semibold text-brand-40 text-uppercase">{{ viewDate | calendarDate:(view + 'ViewTitle'):lang }}</p>
    </div>
    <div class="col-md-4 text-end">
      <div class="text-brand-40 cursor-pointer" mwlCalendarNextView [view]="view" [(viewDate)]="viewDate" role="button" tabindex="0"
        (viewDateChange)="onViewChange(viewDate)">
        <img loading="lazy" src="./assets/images/calendar/arrow_right_calendar.svg" alt="icon_next | Lumsa" style="width: 16px; height: 28px;">
      </div>
    </div>
  </div>
  <br />
  <div>
    <mwl-calendar-month-view [viewDate]="viewDate" [events]="events" [translate]="lang" [locale]="lang"
      [weekStartsOn]="1" [refresh]="refresh" [activeDayIsOpen]="activeDayIsOpen" [headerTemplate]="customHeaderTemplate"
      (dayClicked)="dayClicked($event.day)" (viewChange)="onViewChange($event)"
      (eventClicked)="handleEvent('Clicked', $event.event)" aria-hidden="true">
    </mwl-calendar-month-view>
    <ng-template #customHeaderTemplate let-day="day">
      <div role="row" class="cal-cell-row cal-header ">
        <div tabindex="0" role="columnheader" class="cal-cell cal-past ">
          <span class="d-none d-lg-block">{{ "CALENDAR_DAY.COMPLETE.0" | translate }}</span>
          <span class="d-block d-lg-none">{{ "CALENDAR_DAY.ABBREVIATE.0" | translate }}</span>
        </div>
        <div tabindex="0" role="columnheader" class="cal-cell cal-today ">
          <span class="d-none d-lg-block">{{ "CALENDAR_DAY.COMPLETE.1" | translate }}</span>
          <span class="d-block d-lg-none">{{ "CALENDAR_DAY.ABBREVIATE.1" | translate }}</span>
        </div>
        <div tabindex="0" role="columnheader" class="cal-cell cal-future ">
          <span class="d-none d-lg-block">{{ "CALENDAR_DAY.COMPLETE.2" | translate }}</span>
          <span class="d-block d-lg-none">{{ "CALENDAR_DAY.ABBREVIATE.2" | translate }}</span>
        </div>
        <div tabindex="0" role="columnheader" class="cal-cell cal-future ">
          <span class="d-none d-lg-block">{{ "CALENDAR_DAY.COMPLETE.3" | translate }}</span>
          <span class="d-block d-lg-none">{{ "CALENDAR_DAY.ABBREVIATE.3" | translate }}</span>
        </div>
        <div tabindex="0" role="columnheader" class="cal-cell cal-future ">
          <span class="d-none d-lg-block">{{ "CALENDAR_DAY.COMPLETE.4" | translate }}</span>
          <span class="d-block d-lg-none">{{ "CALENDAR_DAY.ABBREVIATE.4" | translate }}</span>
        </div>
        <div tabindex="0" role="columnheader" class="cal-cell cal-future cal-weekend ">
          <span class="d-none d-lg-block">{{ "CALENDAR_DAY.COMPLETE.5" | translate }}</span>
          <span class="d-block d-lg-none">{{ "CALENDAR_DAY.ABBREVIATE.5" | translate }}</span>
        </div>
        <div tabindex="0" role="columnheader" class="cal-cell cal-future cal-weekend ">
          <span class="d-none d-lg-block">{{ "CALENDAR_DAY.COMPLETE.6" | translate }}</span>
          <span class="d-block d-lg-none">{{ "CALENDAR_DAY.ABBREVIATE.6" | translate }}</span>
        </div>
      </div>
    </ng-template>
  </div>
</ng-container>